/// THIS IS AUTOGENERATED FILE! Generation time: 2025-11-26T08:18:29.4003960+00:00
// NAMED ENUMS
export var Merchant;
(function (Merchant) {
    Merchant[Merchant["Yookassa"] = 0] = "Yookassa";
    Merchant[Merchant["Xsolla"] = 1] = "Xsolla";
    Merchant[Merchant["Odnoklassniki"] = 2] = "Odnoklassniki";
    Merchant[Merchant["Vkontaktecom"] = 3] = "Vkontaktecom";
    Merchant[Merchant["Vkontakteplay"] = 4] = "Vkontakteplay";
    Merchant[Merchant["Yandexgames"] = 5] = "Yandexgames";
    Merchant[Merchant["Absolutegames"] = 6] = "Absolutegames";
    Merchant[Merchant["Kongregate"] = 7] = "Kongregate";
    Merchant[Merchant["Stripe"] = 8] = "Stripe";
    Merchant[Merchant["Facebookgames"] = 9] = "Facebookgames";
    Merchant[Merchant["Moneymailru"] = 10] = "Moneymailru";
    Merchant[Merchant["Bank131"] = 11] = "Bank131";
    Merchant[Merchant["Wizq"] = 12] = "Wizq";
    Merchant[Merchant["Rustore"] = 13] = "Rustore";
    Merchant[Merchant["Telegram"] = 14] = "Telegram";
    Merchant[Merchant["Googleplay"] = 15] = "Googleplay";
    Merchant[Merchant["Appstore"] = 16] = "Appstore";
    Merchant[Merchant["Steam"] = 17] = "Steam";
    Merchant[Merchant["Onestore"] = 18] = "Onestore";
    Merchant[Merchant["Facebookinstantgames"] = 19] = "Facebookinstantgames";
    Merchant[Merchant["Epicgamesstore"] = 20] = "Epicgamesstore";
    Merchant[Merchant["Promocode"] = 21] = "Promocode";
    Merchant[Merchant["Yandexgamesbonusmerchant"] = 22] = "Yandexgamesbonusmerchant";
    Merchant[Merchant["Aghanim"] = 23] = "Aghanim";
    Merchant[Merchant["Crazygames"] = 24] = "Crazygames";
    Merchant[Merchant["Crossplay"] = 25] = "Crossplay";
    Merchant[Merchant["Wechat"] = 26] = "Wechat";
    Merchant[Merchant["Dummy"] = 100] = "Dummy";
})(Merchant || (Merchant = {}));
export var OrderState;
(function (OrderState) {
    OrderState[OrderState["Created"] = 0] = "Created";
    OrderState[OrderState["Waitingforpayment"] = 1] = "Waitingforpayment";
    OrderState[OrderState["Payedwaitingforsending"] = 2] = "Payedwaitingforsending";
    OrderState[OrderState["Cancelledpaid"] = 898] = "Cancelledpaid";
    OrderState[OrderState["Cancelled"] = 899] = "Cancelled";
    OrderState[OrderState["Completed"] = 999] = "Completed";
})(OrderState || (OrderState = {}));
export var SocialIdentifierType;
(function (SocialIdentifierType) {
    SocialIdentifierType[SocialIdentifierType["Unspecified"] = 0] = "Unspecified";
    SocialIdentifierType[SocialIdentifierType["Email"] = 1] = "Email";
    SocialIdentifierType[SocialIdentifierType["Telegram"] = 2] = "Telegram";
    SocialIdentifierType[SocialIdentifierType["Firebase"] = 3] = "Firebase";
    SocialIdentifierType[SocialIdentifierType["Vkontakteplay"] = 4] = "Vkontakteplay";
    SocialIdentifierType[SocialIdentifierType["Odnoklassniki"] = 5] = "Odnoklassniki";
    SocialIdentifierType[SocialIdentifierType["Vkontaktecom"] = 6] = "Vkontaktecom";
    SocialIdentifierType[SocialIdentifierType["Yandexgames"] = 7] = "Yandexgames";
    SocialIdentifierType[SocialIdentifierType["Fxid"] = 8] = "Fxid";
    SocialIdentifierType[SocialIdentifierType["Yandexgamesguest"] = 9] = "Yandexgamesguest";
    SocialIdentifierType[SocialIdentifierType["Facebook"] = 10] = "Facebook";
    SocialIdentifierType[SocialIdentifierType["Google"] = 11] = "Google";
    SocialIdentifierType[SocialIdentifierType["Apple"] = 12] = "Apple";
    SocialIdentifierType[SocialIdentifierType["Absolutegamesguest"] = 13] = "Absolutegamesguest";
    SocialIdentifierType[SocialIdentifierType["Absolutegames"] = 14] = "Absolutegames";
    SocialIdentifierType[SocialIdentifierType["Kongregateguest"] = 15] = "Kongregateguest";
    SocialIdentifierType[SocialIdentifierType["Kongregate"] = 16] = "Kongregate";
    SocialIdentifierType[SocialIdentifierType["Vkontaktecomoauth"] = 17] = "Vkontaktecomoauth";
    SocialIdentifierType[SocialIdentifierType["Xsolla"] = 18] = "Xsolla";
    SocialIdentifierType[SocialIdentifierType["Facebookgames"] = 19] = "Facebookgames";
    SocialIdentifierType[SocialIdentifierType["Crazygamesguest"] = 20] = "Crazygamesguest";
    SocialIdentifierType[SocialIdentifierType["Crazygames"] = 21] = "Crazygames";
    SocialIdentifierType[SocialIdentifierType["Mygamesid"] = 22] = "Mygamesid";
    SocialIdentifierType[SocialIdentifierType["Wizq"] = 23] = "Wizq";
    SocialIdentifierType[SocialIdentifierType["Steam"] = 25] = "Steam";
    SocialIdentifierType[SocialIdentifierType["Egs"] = 26] = "Egs";
    SocialIdentifierType[SocialIdentifierType["Twitch"] = 27] = "Twitch";
})(SocialIdentifierType || (SocialIdentifierType = {}));
// EVENT-SPECIFIC ENUMS
export var AnalyticsEventDownloadStatusState;
(function (AnalyticsEventDownloadStatusState) {
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Added"] = 0] = "Added";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Resuming"] = 1] = "Resuming";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Checking"] = 2] = "Checking";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Loading"] = 3] = "Loading";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Downloading"] = 4] = "Downloading";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Finished"] = 5] = "Finished";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Seeding"] = 6] = "Seeding";
    AnalyticsEventDownloadStatusState[AnalyticsEventDownloadStatusState["Idle"] = 7] = "Idle";
})(AnalyticsEventDownloadStatusState || (AnalyticsEventDownloadStatusState = {}));
export class AnalyticsEvents {
    constructor(sender) {
        this._sender = sender;
    }
    /**
     * Event Name: download_request_track
     * Event ID: 781965163
     * Description: Download request tracking
     */
    BuildDownloadRequestTrack(analyticsEvent, game, sessionIdStr, url, queryString, query, sessionId, cookies) {
        return {
            ...analyticsEvent,
            EventId: 781965163, S1: game, S2: sessionIdStr, S3: url, S4: queryString, S5: query, I1: sessionId, J2: cookies
        };
    }
    /**
     * Event Name: download_request_track
     * Event ID: 781965163
     * Description: Download request tracking
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param url Url
     * @param queryString QueryString
     * @param query Query
     * @param sessionId SessionId
     * @param cookies Cookies
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendDownloadRequestTrack(game, sessionIdStr, url, queryString, query, sessionId, cookies, createdAt) {
        const eventAnalyticsEvent = this.BuildDownloadRequestTrack(this._sender.BuildEvent(createdAt), game, sessionIdStr, url, queryString, query, sessionId, cookies);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: download_track
     * Event ID: 781965166
     * Description: Download file with session tracking
     */
    BuildDownloadTrack(analyticsEvent, game, sessionIdStr, sessionId) {
        return {
            ...analyticsEvent,
            EventId: 781965166, S1: game, S2: sessionIdStr, I1: sessionId
        };
    }
    /**
     * Event Name: download_track
     * Event ID: 781965166
     * Description: Download file with session tracking
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param sessionId SessionId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendDownloadTrack(game, sessionIdStr, sessionId, createdAt) {
        const eventAnalyticsEvent = this.BuildDownloadTrack(this._sender.BuildEvent(createdAt), game, sessionIdStr, sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: authenticate_with_ext_id_signup
     * Event ID: 781965164
     * Description: AuthenticateWithExternalId signup
     */
    BuildAuthenticateWithExtIdSignup(analyticsEvent, game, sessionIdStr, email, sessionId) {
        return {
            ...analyticsEvent,
            EventId: 781965164, S1: game, S2: sessionIdStr, S3: email, I1: sessionId
        };
    }
    /**
     * Event Name: authenticate_with_ext_id_signup
     * Event ID: 781965164
     * Description: AuthenticateWithExternalId signup
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param email Email
     * @param sessionId SessionId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendAuthenticateWithExtIdSignup(game, sessionIdStr, email, sessionId, createdAt) {
        const eventAnalyticsEvent = this.BuildAuthenticateWithExtIdSignup(this._sender.BuildEvent(createdAt), game, sessionIdStr, email, sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: authenticate_with_ext_id_login
     * Event ID: 781965165
     * Description: AuthenticateWithExternalId login
     */
    BuildAuthenticateWithExtIdLogin(analyticsEvent, game, sessionIdStr, email, sessionId) {
        return {
            ...analyticsEvent,
            EventId: 781965165, S1: game, S2: sessionIdStr, S3: email, I1: sessionId
        };
    }
    /**
     * Event Name: authenticate_with_ext_id_login
     * Event ID: 781965165
     * Description: AuthenticateWithExternalId login
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param email Email
     * @param sessionId SessionId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendAuthenticateWithExtIdLogin(game, sessionIdStr, email, sessionId, createdAt) {
        const eventAnalyticsEvent = this.BuildAuthenticateWithExtIdLogin(this._sender.BuildEvent(createdAt), game, sessionIdStr, email, sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: download_status
     * Event ID: 781965176
     * Description: Download status
     */
    BuildDownloadStatus(analyticsEvent, branch, game, sessionId, state, uploadSpeedBytes, downloadSeedBytes, buildId, progress) {
        return {
            ...analyticsEvent,
            EventId: 781965176, S1: branch, S2: game, I1: sessionId, I2: state, I3: uploadSpeedBytes, I4: downloadSeedBytes, I5: buildId, F1: progress
        };
    }
    /**
     * Event Name: download_status
     * Event ID: 781965176
     * Description: Download status
     * @param branch Branch
     * @param game Game
     * @param sessionId SessionId
     * @param state State
     * @param uploadSpeedBytes UploadSpeedBytes
     * @param downloadSeedBytes DownloadSeedBytes
     * @param buildId BuildId
     * @param progress Progress
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendDownloadStatus(branch, game, sessionId, state, uploadSpeedBytes, downloadSeedBytes, buildId, progress, createdAt) {
        const eventAnalyticsEvent = this.BuildDownloadStatus(this._sender.BuildEvent(createdAt), branch, game, sessionId, state, uploadSpeedBytes, downloadSeedBytes, buildId, progress);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: change_state
     * Event ID: 781965177
     * Description: Change state
     */
    BuildChangeState(analyticsEvent, game, sessionId, fromState, toState, timeBetweenSeconds) {
        return {
            ...analyticsEvent,
            EventId: 781965177, S1: game, I1: sessionId, I2: fromState, I3: toState, F1: timeBetweenSeconds
        };
    }
    /**
     * Event Name: change_state
     * Event ID: 781965177
     * Description: Change state
     * @param game Game
     * @param sessionId SessionId
     * @param fromState FromState
     * @param toState ToState
     * @param timeBetweenSeconds TimeBetweenSeconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendChangeState(game, sessionId, fromState, toState, timeBetweenSeconds, createdAt) {
        const eventAnalyticsEvent = this.BuildChangeState(this._sender.BuildEvent(createdAt), game, sessionId, fromState, toState, timeBetweenSeconds);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: game_connected
     * Event ID: 781965178
     * Description: Game connected
     */
    BuildGameConnected(analyticsEvent, game, gameId) {
        return {
            ...analyticsEvent,
            EventId: 781965178, S1: game, S2: gameId
        };
    }
    /**
     * Event Name: game_connected
     * Event ID: 781965178
     * Description: Game connected
     * @param game Game
     * @param gameId GameId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendGameConnected(game, gameId, createdAt) {
        const eventAnalyticsEvent = this.BuildGameConnected(this._sender.BuildEvent(createdAt), game, gameId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: launcher_started
     * Event ID: 781965179
     * Description: Launcher started
     */
    BuildLauncherStarted(analyticsEvent, appCode, clientGuid, fxapiApiType, fxapiCefVersion, fxapiAppVersion, fxapiLoaderName, fxapiHwProfileGuid, fxapiIsSteamdeck) {
        return {
            ...analyticsEvent,
            EventId: 781965179, S1: appCode, S2: clientGuid, S3: fxapiApiType, S4: fxapiCefVersion, S5: fxapiAppVersion, S6: fxapiLoaderName, S7: fxapiHwProfileGuid, I1: fxapiIsSteamdeck
        };
    }
    /**
     * Event Name: launcher_started
     * Event ID: 781965179
     * Description: Launcher started
     * @param appCode AppCode
     * @param clientGuid ClientGuid
     * @param fxapiApiType FxapiApiType
     * @param fxapiCefVersion FxapiCefVersion
     * @param fxapiAppVersion FxapiAppVersion
     * @param fxapiLoaderName FxapiLoaderName
     * @param fxapiHwProfileGuid FxapiHwProfileGuid
     * @param fxapiIsSteamdeck FxapiIsSteamdeck
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendLauncherStarted(appCode, clientGuid, fxapiApiType, fxapiCefVersion, fxapiAppVersion, fxapiLoaderName, fxapiHwProfileGuid, fxapiIsSteamdeck, createdAt) {
        const eventAnalyticsEvent = this.BuildLauncherStarted(this._sender.BuildEvent(createdAt), appCode, clientGuid, fxapiApiType, fxapiCefVersion, fxapiAppVersion, fxapiLoaderName, fxapiHwProfileGuid, fxapiIsSteamdeck);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: order_state_changed
     * Event ID: 781965182
     * Description: Order state changed
     */
    BuildOrderStateChanged(analyticsEvent, game, skuCode, additionalProductsSkus, currency, currencySkuPrice, merchant, merchantCurrency, paymentMethod, orderId, orderPublicId, orderState, previousOrderState, merchantId, usdPriceTier, merchantValue) {
        return {
            ...analyticsEvent,
            EventId: 781965182, S1: game, S2: skuCode, S3: additionalProductsSkus, S4: currency, S5: currencySkuPrice, S6: merchant, S7: merchantCurrency, S8: paymentMethod, S9: orderId, S10: orderPublicId, I1: orderState, I2: previousOrderState, I3: merchantId, F1: usdPriceTier, F2: merchantValue
        };
    }
    /**
     * Event Name: order_state_changed
     * Event ID: 781965182
     * Description: Order state changed
     * @param game Game
     * @param skuCode Product sku
     * @param additionalProductsSkus Additional products skus
     * @param currency Currency
     * @param currencySkuPrice Price in currency
     * @param merchant Merchant used for payment
     * @param merchantCurrency Currency that merchant used for payment
     * @param paymentMethod Test payment method or not
     * @param orderId Id of the order in database
     * @param orderPublicId Public id of the order in database
     * @param orderState OrderState
     * @param previousOrderState PreviousOrderState
     * @param merchantId Merchant used for payment
     * @param usdPriceTier Price in usd for price tier that was chosen
     * @param merchantValue Amount of merchant_currency that merchant added for the order
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendOrderStateChanged(game, // Game 
    skuCode, // Product sku 
    additionalProductsSkus, // Additional products skus 
    currency, // Currency 
    currencySkuPrice, // Price in currency 
    merchant, // Merchant used for payment 
    merchantCurrency, // Currency that merchant used for payment 
    paymentMethod, // Test payment method or not 
    orderId, // Id of the order in database 
    orderPublicId, // Public id of the order in database 
    orderState, previousOrderState, merchantId, // Merchant used for payment 
    usdPriceTier, // Price in usd for price tier that was chosen 
    merchantValue, // Amount of merchant_currency that merchant added for the order 
    createdAt) {
        const eventAnalyticsEvent = this.BuildOrderStateChanged(this._sender.BuildEvent(createdAt), game, skuCode, additionalProductsSkus, currency, currencySkuPrice, merchant, merchantCurrency, paymentMethod, orderId, orderPublicId, orderState, previousOrderState, merchantId, usdPriceTier, merchantValue);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: social_identifier_added
     * Event ID: 781965183
     * Description: Social identifier added
     */
    BuildSocialIdentifierAdded(analyticsEvent, identifier, identifierType) {
        return {
            ...analyticsEvent,
            EventId: 781965183, S1: identifier, I1: identifierType
        };
    }
    /**
     * Event Name: social_identifier_added
     * Event ID: 781965183
     * Description: Social identifier added
     * @param identifier Identifier
     * @param identifierType IdentifierType
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSocialIdentifierAdded(identifier, identifierType, createdAt) {
        const eventAnalyticsEvent = this.BuildSocialIdentifierAdded(this._sender.BuildEvent(createdAt), identifier, identifierType);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: user_review
     * Event ID: 781965184
     * Description: User submitted a review
     */
    BuildUserReview(analyticsEvent, game, reviewText, score) {
        return {
            ...analyticsEvent,
            EventId: 781965184, S1: game, S2: reviewText, I1: score
        };
    }
    /**
     * Event Name: user_review
     * Event ID: 781965184
     * Description: User submitted a review
     * @param game Game
     * @param reviewText ReviewText
     * @param score Score
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendUserReview(game, reviewText, score, createdAt) {
        const eventAnalyticsEvent = this.BuildUserReview(this._sender.BuildEvent(createdAt), game, reviewText, score);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_personal_information_form_shown
     * Event ID: 781965186
     * Description: Web UI personal information form shown
     */
    BuildWebUiPersonalInformationFormShown(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965186, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_personal_information_form_shown
     * Event ID: 781965186
     * Description: Web UI personal information form shown
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiPersonalInformationFormShown(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiPersonalInformationFormShown(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_personal_information_form_autofilled
     * Event ID: 781965187
     * Description: Web UI personal information form autofilled
     */
    BuildWebUiPersonalInformationFormAutofilled(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965187, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_personal_information_form_autofilled
     * Event ID: 781965187
     * Description: Web UI personal information form autofilled
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiPersonalInformationFormAutofilled(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiPersonalInformationFormAutofilled(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_personal_information_form_submitted
     * Event ID: 781965188
     * Description: Web UI personal information form submitted
     */
    BuildWebUiPersonalInformationFormSubmitted(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965188, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_personal_information_form_submitted
     * Event ID: 781965188
     * Description: Web UI personal information form submitted
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiPersonalInformationFormSubmitted(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiPersonalInformationFormSubmitted(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_bank131_form_shown
     * Event ID: 781965189
     * Description: Web UI bank131 form shown
     */
    BuildWebUiBank131FormShown(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965189, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_bank131_form_shown
     * Event ID: 781965189
     * Description: Web UI bank131 form shown
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiBank131FormShown(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiBank131FormShown(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_bank131_form_card_clicked
     * Event ID: 781965190
     * Description: Web UI bank131 form card clicked
     */
    BuildWebUiBank131FormCardClicked(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965190, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_bank131_form_card_clicked
     * Event ID: 781965190
     * Description: Web UI bank131 form card clicked
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiBank131FormCardClicked(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiBank131FormCardClicked(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_bank131_form_fps_clicked
     * Event ID: 781965191
     * Description: Web UI bank131 form fps clicked
     */
    BuildWebUiBank131FormFpsClicked(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965191, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_bank131_form_fps_clicked
     * Event ID: 781965191
     * Description: Web UI bank131 form fps clicked
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiBank131FormFpsClicked(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiBank131FormFpsClicked(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_bank131_form_card_submitted
     * Event ID: 781965192
     * Description: Web UI bank131 form card submitted
     */
    BuildWebUiBank131FormCardSubmitted(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965192, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_bank131_form_card_submitted
     * Event ID: 781965192
     * Description: Web UI bank131 form card submitted
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiBank131FormCardSubmitted(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiBank131FormCardSubmitted(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: web_ui_bank131_form_fps_submitted
     * Event ID: 781965193
     * Description: Web UI bank131 form fps submitted
     */
    BuildWebUiBank131FormFpsSubmitted(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965193, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: web_ui_bank131_form_fps_submitted
     * Event ID: 781965193
     * Description: Web UI bank131 form fps submitted
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendWebUiBank131FormFpsSubmitted(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildWebUiBank131FormFpsSubmitted(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: payment_bank131_fps_data_received
     * Event ID: 781965194
     * Description: Payment bank131 fps data received
     */
    BuildPaymentBank131FpsDataReceived(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965194, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: payment_bank131_fps_data_received
     * Event ID: 781965194
     * Description: Payment bank131 fps data received
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendPaymentBank131FpsDataReceived(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildPaymentBank131FpsDataReceived(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: payment_bank131_fps_data_receiving_error
     * Event ID: 781965195
     * Description: Payment bank131 fps data receiving error
     */
    BuildPaymentBank131FpsDataReceivingError(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965195, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: payment_bank131_fps_data_receiving_error
     * Event ID: 781965195
     * Description: Payment bank131 fps data receiving error
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendPaymentBank131FpsDataReceivingError(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildPaymentBank131FpsDataReceivingError(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: payment_bank131_card_success
     * Event ID: 781965196
     * Description: Payment bank131 card success
     */
    BuildPaymentBank131CardSuccess(analyticsEvent, publicOrderId, source) {
        return {
            ...analyticsEvent,
            EventId: 781965196, S1: publicOrderId, S2: source
        };
    }
    /**
     * Event Name: payment_bank131_card_success
     * Event ID: 781965196
     * Description: Payment bank131 card success
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendPaymentBank131CardSuccess(publicOrderId, source, createdAt) {
        const eventAnalyticsEvent = this.BuildPaymentBank131CardSuccess(this._sender.BuildEvent(createdAt), publicOrderId, source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: payment_bank131_card_cancelled
     * Event ID: 781965197
     * Description: Payment bank131 card canceled
     */
    BuildPaymentBank131CardCancelled(analyticsEvent, orderId) {
        return {
            ...analyticsEvent,
            EventId: 781965197, I1: orderId
        };
    }
    /**
     * Event Name: payment_bank131_card_cancelled
     * Event ID: 781965197
     * Description: Payment bank131 card canceled
     * @param orderId OrderId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendPaymentBank131CardCancelled(orderId, createdAt) {
        const eventAnalyticsEvent = this.BuildPaymentBank131CardCancelled(this._sender.BuildEvent(createdAt), orderId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: payment_bank131_fps_success
     * Event ID: 781965198
     * Description: Payment bank131 fps success
     */
    BuildPaymentBank131FpsSuccess(analyticsEvent, orderId) {
        return {
            ...analyticsEvent,
            EventId: 781965198, I1: orderId
        };
    }
    /**
     * Event Name: payment_bank131_fps_success
     * Event ID: 781965198
     * Description: Payment bank131 fps success
     * @param orderId OrderId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendPaymentBank131FpsSuccess(orderId, createdAt) {
        const eventAnalyticsEvent = this.BuildPaymentBank131FpsSuccess(this._sender.BuildEvent(createdAt), orderId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: game_loading_started
     * Event ID: 781965202
     * Description: Game loading started
     */
    BuildGameLoadingStarted(analyticsEvent, game, sessionId, buildId) {
        return {
            ...analyticsEvent,
            EventId: 781965202, S1: game, S2: sessionId, I1: buildId
        };
    }
    /**
     * Event Name: game_loading_started
     * Event ID: 781965202
     * Description: Game loading started
     * @param game Game name
     * @param sessionId Session id
     * @param buildId Build version
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendGameLoadingStarted(game, // Game name 
    sessionId, // Session id 
    buildId, // Build version 
    createdAt) {
        const eventAnalyticsEvent = this.BuildGameLoadingStarted(this._sender.BuildEvent(createdAt), game, sessionId, buildId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: game_launched
     * Event ID: 781965203
     * Description: Game launched successfully
     */
    BuildGameLaunched(analyticsEvent, game, sessionId, buildId, loadingTimeSeconds) {
        return {
            ...analyticsEvent,
            EventId: 781965203, S1: game, S2: sessionId, I1: buildId, F1: loadingTimeSeconds
        };
    }
    /**
     * Event Name: game_launched
     * Event ID: 781965203
     * Description: Game launched successfully
     * @param game Game name
     * @param sessionId Session id
     * @param buildId Build version
     * @param loadingTimeSeconds Loading time in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendGameLaunched(game, // Game name 
    sessionId, // Session id 
    buildId, // Build version 
    loadingTimeSeconds, // Loading time in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildGameLaunched(this._sender.BuildEvent(createdAt), game, sessionId, buildId, loadingTimeSeconds);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: client_exception
     * Event ID: 781965204
     * Description: Client exception occurred
     */
    BuildClientException(analyticsEvent, game, exceptionType, exceptionMessage, stackTrace, sessionId) {
        return {
            ...analyticsEvent,
            EventId: 781965204, S1: game, S2: exceptionType, S3: exceptionMessage, S4: stackTrace, S5: sessionId
        };
    }
    /**
     * Event Name: client_exception
     * Event ID: 781965204
     * Description: Client exception occurred
     * @param game Game name
     * @param exceptionType Exception type
     * @param exceptionMessage Exception message
     * @param stackTrace Stack trace
     * @param sessionId Session id
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendClientException(game, // Game name 
    exceptionType, // Exception type 
    exceptionMessage, // Exception message 
    stackTrace, // Stack trace 
    sessionId, // Session id 
    createdAt) {
        const eventAnalyticsEvent = this.BuildClientException(this._sender.BuildEvent(createdAt), game, exceptionType, exceptionMessage, stackTrace, sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: client_performance
     * Event ID: 781965205
     * Description: Client performance metrics
     */
    BuildClientPerformance(analyticsEvent, game, sessionId, memoryMb, fps, clicksCount, mouseDistancePixels) {
        return {
            ...analyticsEvent,
            EventId: 781965205, S1: game, S2: sessionId, I1: memoryMb, I2: fps, I3: clicksCount, F1: mouseDistancePixels
        };
    }
    /**
     * Event Name: client_performance
     * Event ID: 781965205
     * Description: Client performance metrics
     * @param game Game name
     * @param sessionId Session id
     * @param memoryMb Memory usage in MB
     * @param fps Frames per second
     * @param clicksCount Number of clicks
     * @param mouseDistancePixels Mouse distance in pixels
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendClientPerformance(game, // Game name 
    sessionId, // Session id 
    memoryMb, // Memory usage in MB 
    fps, // Frames per second 
    clicksCount, // Number of clicks 
    mouseDistancePixels, // Mouse distance in pixels 
    createdAt) {
        const eventAnalyticsEvent = this.BuildClientPerformance(this._sender.BuildEvent(createdAt), game, sessionId, memoryMb, fps, clicksCount, mouseDistancePixels);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_user_authentication_forced
     * Event ID: 781965206
     * Description: SDK user authentication forced
     */
    BuildSdkUserAuthenticationForced(analyticsEvent, sessionId, game, adapter, providerId, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965206, S1: sessionId, S2: game, S3: adapter, S4: providerId, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_user_authentication_forced
     * Event ID: 781965206
     * Description: SDK user authentication forced
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param providerId Auth provider id
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkUserAuthenticationForced(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    providerId, // Auth provider id 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkUserAuthenticationForced(this._sender.BuildEvent(createdAt), sessionId, game, adapter, providerId, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_user_logged_in_fxid
     * Event ID: 781965207
     * Description: SDK user logged in FxId
     */
    BuildSdkUserLoggedInFxid(analyticsEvent, sessionId, game, adapter, domain, screenResolution, os, browser, browserVersion, sessionNumber, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965207, S1: sessionId, S2: game, S3: adapter, S4: domain, S5: screenResolution, S6: os, S7: browser, S8: browserVersion, I1: sessionNumber, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_user_logged_in_fxid
     * Event ID: 781965207
     * Description: SDK user logged in FxId
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param domain Domain
     * @param screenResolution Screen resolution (e.g. 1920x1080)
     * @param os Operating system
     * @param browser Browser name
     * @param browserVersion Browser version
     * @param sessionNumber Session number (incremental counter)
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkUserLoggedInFxid(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    domain, // Domain 
    screenResolution, // Screen resolution (e.g. 1920x1080) 
    os, // Operating system 
    browser, // Browser name 
    browserVersion, // Browser version 
    sessionNumber, // Session number (incremental counter) 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkUserLoggedInFxid(this._sender.BuildEvent(createdAt), sessionId, game, adapter, domain, screenResolution, os, browser, browserVersion, sessionNumber, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_iframe_modal_opened
     * Event ID: 781965208
     * Description: SDK iframe modal opened
     */
    BuildSdkIframeModalOpened(analyticsEvent, sessionId, game, adapter, url, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965208, S1: sessionId, S2: game, S3: adapter, S4: url, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_iframe_modal_opened
     * Event ID: 781965208
     * Description: SDK iframe modal opened
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param url Modal URL
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkIframeModalOpened(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    url, // Modal URL 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkIframeModalOpened(this._sender.BuildEvent(createdAt), sessionId, game, adapter, url, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_language_changed
     * Event ID: 781965209
     * Description: SDK language changed
     */
    BuildSdkLanguageChanged(analyticsEvent, sessionId, game, adapter, oldLang, newLang, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965209, S1: sessionId, S2: game, S3: adapter, S4: oldLang, S5: newLang, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_language_changed
     * Event ID: 781965209
     * Description: SDK language changed
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param oldLang Old language
     * @param newLang New language
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkLanguageChanged(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    oldLang, // Old language 
    newLang, // New language 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkLanguageChanged(this._sender.BuildEvent(createdAt), sessionId, game, adapter, oldLang, newLang, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_report_modal_opened
     * Event ID: 781965210
     * Description: SDK report modal opened
     */
    BuildSdkReportModalOpened(analyticsEvent, sessionId, game, adapter, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965210, S1: sessionId, S2: game, S3: adapter, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_report_modal_opened
     * Event ID: 781965210
     * Description: SDK report modal opened
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkReportModalOpened(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkReportModalOpened(this._sender.BuildEvent(createdAt), sessionId, game, adapter, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_product_purchase_requested
     * Event ID: 781965211
     * Description: SDK product purchase requested
     */
    BuildSdkProductPurchaseRequested(analyticsEvent, sessionId, game, adapter, productSku, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965211, S1: sessionId, S2: game, S3: adapter, S4: productSku, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_product_purchase_requested
     * Event ID: 781965211
     * Description: SDK product purchase requested
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param productSku Product SKU
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkProductPurchaseRequested(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    productSku, // Product SKU 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkProductPurchaseRequested(this._sender.BuildEvent(createdAt), sessionId, game, adapter, productSku, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_product_purchase_completed
     * Event ID: 781965212
     * Description: SDK product purchase completed
     */
    BuildSdkProductPurchaseCompleted(analyticsEvent, sessionId, game, adapter, productSku, currency, transactionId, timeFromSessionStart, currencyAmount, usdAmount) {
        return {
            ...analyticsEvent,
            EventId: 781965212, S1: sessionId, S2: game, S3: adapter, S4: productSku, S5: currency, S6: transactionId, F1: timeFromSessionStart, F2: currencyAmount, F3: usdAmount
        };
    }
    /**
     * Event Name: sdk_product_purchase_completed
     * Event ID: 781965212
     * Description: SDK product purchase completed
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param productSku Product SKU
     * @param currency Currency code
     * @param transactionId Transaction id
     * @param timeFromSessionStart Time from session start in seconds
     * @param currencyAmount Amount in currency
     * @param usdAmount Amount in USD
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkProductPurchaseCompleted(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    productSku, // Product SKU 
    currency, // Currency code 
    transactionId, // Transaction id 
    timeFromSessionStart, // Time from session start in seconds 
    currencyAmount, // Amount in currency 
    usdAmount, // Amount in USD 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkProductPurchaseCompleted(this._sender.BuildEvent(createdAt), sessionId, game, adapter, productSku, currency, transactionId, timeFromSessionStart, currencyAmount, usdAmount);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_product_purchase_error
     * Event ID: 781965213
     * Description: SDK product purchase error
     */
    BuildSdkProductPurchaseError(analyticsEvent, sessionId, game, adapter, productSku, error, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965213, S1: sessionId, S2: game, S3: adapter, S4: productSku, S5: error, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_product_purchase_error
     * Event ID: 781965213
     * Description: SDK product purchase error
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param productSku Product SKU
     * @param error Error message
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkProductPurchaseError(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    productSku, // Product SKU 
    error, // Error message 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkProductPurchaseError(this._sender.BuildEvent(createdAt), sessionId, game, adapter, productSku, error, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    /**
     * Event Name: sdk_game_started
     * Event ID: 781965214
     * Description: SDK game started
     */
    BuildSdkGameStarted(analyticsEvent, sessionId, game, adapter, timeFromSessionStart) {
        return {
            ...analyticsEvent,
            EventId: 781965214, S1: sessionId, S2: game, S3: adapter, F1: timeFromSessionStart
        };
    }
    /**
     * Event Name: sdk_game_started
     * Event ID: 781965214
     * Description: SDK game started
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    SendSdkGameStarted(sessionId, // Session id 
    game, // Game name 
    adapter, // Adapter type 
    timeFromSessionStart, // Time from session start in seconds 
    createdAt) {
        const eventAnalyticsEvent = this.BuildSdkGameStarted(this._sender.BuildEvent(createdAt), sessionId, game, adapter, timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
}
//# sourceMappingURL=AnalyticsCodegen.js.map